import React, {Fragment, useState} from 'react';

import {Box} from '@material-ui/core';

import EfeWebCam from 'components/efe-webcam/EfeWebCam';
import EfeDragAndDrop from 'components/efe-drag-and-drop/EfeDragAndDrop';
import EfeSignaturePad from 'components/efe-signature-pad/EfeSignaturePad';
import {FileWithPath} from 'react-dropzone';

const getCapture = (url: string) => {
    console.log(url);
};

function Biometrics() {
    const [uploadedFiles] = useState<{values:FileWithPath[]}>({values:[]});
    const [len, setLen] = useState<number>(-1);
    function addFile(file: FileWithPath) {
        if (file && uploadedFiles.values.length < 2) {
            const aux = [...uploadedFiles.values];
            aux.push(file);
            uploadedFiles.values = aux;
            setLen(aux.length);
        }
    }

    const deleteFile = (index: number) => {
        if (uploadedFiles && uploadedFiles.values.length) {
            const aux = [...uploadedFiles.values];
            aux.splice(index, 1);
            uploadedFiles.values = aux;
            setLen(aux.length);
        }
    };
    return (
        <Fragment>
            <Box pt={4}>
                <EfeSignaturePad
                    setSignature={() => {
                        console.log('');
                    }}
                    readonly={false}
                    signature={''}
                    title={'Firma Digitalizadora'}
                    description={
                        'Ingrese su firma dentro del recuadro a continuaci\u00F3n* '
                    }
                />
            </Box>
            <Box pt={8}>
                <EfeDragAndDrop
                    maxSizeFile={10}
                    numFiles={5}
                    file={''}
                    fileList={uploadedFiles.values}
                    loadFile={addFile}
                    deleteFile={deleteFile}
                    length={len}
                />
            </Box>
            <Box pt={8}>
                <EfeWebCam
                    title={'Captura Identificaci\u00F3n'}
                    subtitle={'Captura el frente de tu identificaci\u00F3n'}
                    legend={
                        'Deber\u00EDas brindar autorizaci\u00F3n a la aplicaci\u00F3n para usar cam\u00E1ra desde el navegador'
                    }
                    description={
                        'Por favor valida que que toda la informaci\u00F3n sea legible y clara'
                    }
                    setDniFront={getCapture}
                    numberPhotos={2}
                    setDniBack={getCapture}></EfeWebCam>
            </Box>
        </Fragment>
    );
}

export default Biometrics;
